/**
 * # NoOffersFound
 *
 *
 */
import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import './styles.scss';

export const NoOffersFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="yilu-NoOffersFound">
      <ElementsSDK.Icon.Info />
      <div className="yilu-NoOffersFound-text">
        <ElementsSDK.Typography variant="h4">
          {t('stopover.no-offers.heading.text')}
        </ElementsSDK.Typography>
        <ElementsSDK.Typography variant="p2">
          {t('stopover.no-offers.subHeading.text')}
        </ElementsSDK.Typography>
      </div>
    </section>
  );
};
